// src/components/SkewedTextBox.tsx
import React from "react";
import {
  StyledContentContainer,
  StyledMainText,
  StyledPrefixText,
  StyledSkewedBox,
  StyledSkewedBoxWrapper,
} from "./SkewedTextBox.styled";

interface SkewedTextBoxProps {
  prefixText?: string;
  mainText: string | number;
  backgroundColor?: string;
  textColor?: string;
  skewAngle?: number;
  width?: string;
  height?: string;
}

const SkewedTextBox: React.FC<SkewedTextBoxProps> = ({
  prefixText,
  mainText,
  backgroundColor = "#FFFFFF",
  textColor = "#FFA500",
  skewAngle = -20,
  width,
  height,
}) => {
  return (
    <StyledSkewedBoxWrapper
      $skewAngle={skewAngle}
      $width={width}
      $height={height}
    >
      <StyledSkewedBox
        $backgroundColor={backgroundColor}
        $skewAngle={skewAngle}
      >
        <StyledContentContainer $skewAngle={skewAngle}>
          {prefixText && (
            <StyledPrefixText $textColor={textColor}>
              {prefixText}
            </StyledPrefixText>
          )}{" "}
          <StyledMainText $textColor={textColor}>{mainText}</StyledMainText>
        </StyledContentContainer>
      </StyledSkewedBox>
    </StyledSkewedBoxWrapper>
  );
};

export default SkewedTextBox;
